import { useSelector } from 'react-redux'
import { State } from '../common/types'
import { useEffect, useState } from 'react'

const useDirection = () => {
  const { locale } = useSelector((state: State) => state.user)

  const rtlLocales = ['ar_YE', 'ar_SA', 'he_IL']
  const [isRTL, setIsRTL] = useState(rtlLocales.includes(locale))

  useEffect(() => {
    setIsRTL(rtlLocales.includes(locale))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale, setIsRTL])

  return {
    isRTL
  }
}

export default useDirection
